import { render, staticRenderFns } from "./convocation-info.view.vue?vue&type=template&id=328cf22e&scoped=true&lang=pug"
import script from "./convocation-info.view.vue?vue&type=script&lang=ts"
export * from "./convocation-info.view.vue?vue&type=script&lang=ts"
import style0 from "./convocation-info.view.vue?vue&type=style&index=0&id=328cf22e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328cf22e",
  null
  
)

export default component.exports